import request from './../../../utils/request/index'
import apis from './../../../const/apis';
export function imageUploadService(image: File, onUploadProgress = _params => {}) {
    const formData = new window.FormData();
    formData.append('Filedata', image);
  
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    };
  
    return request.post<{
      image_info: {
        format: string;
        width: number;
        height: number;
        mode: number;
        name: string;
        size: number;
        web_uri: string;
      };
      uri: string;
      url: string;
    }>(apis.uploadImage, formData, config)
      .then(res => {
        const { format, width, height, name, mode, web_uri: webUri, size } = res.image_info;
  
        return { name, width, height, format, mode, webUri, size, url: res.url, webUrl: res.url };
      })
      .catch(e => console.log('Error in image upload service: ', { value: `imageUploadService error: ${e}` }));
  }